import { LessonSchedule } from 'src/app/classes/LessonSchedule';

export class Course {
  public id: number;
  public name: string;
  public startDate: string;
  public endDate: string;
  public schedulesIds: number[] = [];
  public lessonSchedules: LessonSchedule[];
  public selectedSchedules: LessonSchedule[];

  public constructor(init?: Partial<Course>) {
    Object.assign(this, init);
  }

}
